//#region Styles
import { Column, Row } from "components/styles";
//#endregion
//#region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
//#endregion

const CustomRenderSelect = ({
	optionsProps,
	value,
	onClick,
	render: Render,
	disabled = false,
	errorText,
	error = false,
}) => {
	return (
		<Column marginTop="15px">
			<Row
				className="flex-start"
				gap="15px"
			>
				{optionsProps.map(({ currentValue, ...restProps }, idx) => {
					return (
						<Render
							key={idx}
							onClick={() => onClick(currentValue)}
							selected={currentValue === value}
							error={error}
							disabled={disabled}
							{...restProps}
						/>
					);
				})}
			</Row>
			<ErrorMessage
				text={errorText}
				error={error}
			/>
		</Column>
	);
};

export default CustomRenderSelect;
